<template>
    <div>
        <h2>My Subscription</h2>
        <vs-divider/>
        <vs-card class="subscription-card">
            <vs-table v-if="hasSubscriptions" :data="stripeSubscriptions.data">
                <template v-slot:thead>
                    <vs-th>Subscription Plan</vs-th>
                    <vs-th>Subscription Start Date</vs-th>
                    <vs-th>Current Period Start Date</vs-th>
                    <vs-th>Current Period End Date</vs-th>
                    <vs-th>Pricing</vs-th>
                    <vs-th>Status</vs-th>
                    <vs-th>Actions</vs-th>
                </template>
                <template v-slot="{data}">
                    <vs-tr v-for="sub in data" :key="sub.id">
                        <slot v-for="item in sub.items.data">
                            <vs-td>{{getProductName(item.plan)}}</vs-td>
                            <vs-td>{{formatDate(sub.created)}}</vs-td>
                            <vs-td>{{formatDate(sub.current_period_start)}}</vs-td>
                            <vs-td>{{formatDate(sub.current_period_end)}}</vs-td>
                            <vs-td>{{(item.plan.amount / 100) + ' ' + item.plan.currency}} {{item.plan.nickname}}</vs-td>
                            <vs-td v-if="sub.cancel_at"><span style="color: red">{{'Subscription ends on ' + formatDate(sub.cancel_at)}} </span></vs-td>
                            <vs-td v-else-if="item.plan.active"><span style="color: green">ACTIVE</span></vs-td>
                            <vs-td v-else><span style="color: red">INACTIVE</span></vs-td>
                            <vs-td>
                                <vs-chip v-if="!sub.cancel_at" color="primary" class="active"><span @click="beforeUpdateSubscription(sub, {cancel_at_period_end: true})/*updateSubscription(sub.id, {cancel_at_period_end: true})*/">Cancel Subscription</span></vs-chip>
                                <vs-chip v-else-if="sub.cancel_at && sub.status === 'active'" color="primary" class="active"><span @click="beforeUpdateSubscription(sub, {cancel_at_period_end: false}, false)">Continue Subscription</span></vs-chip>
                                <vs-chip v-else >Cancel Subscription</vs-chip>
                                <vs-chip v-if="!sub.cancel_at && upgradeablePlans.length > 0" color="primary" class="active"><span @click="() => {changeSubscriptionPlan = true}">Upgrade Plan</span></vs-chip>
                                <vs-chip v-else >Upgrade Plan</vs-chip>
                            </vs-td>
                        </slot>
                    </vs-tr>
                </template>
            </vs-table>
            <slot v-else>
                <div class="no-sub-desc">
                    <p><b>You don't currently have any active subscriptions to Chefstein service.</b></p>
                    <p>Please start by adding your billing information and selecting the preferred subscription package.</p>
                </div>
                <div class="vx-col md:w-1/2 mt-5">
                    <vs-button
                        @click="$router.push('/subscription').catch(() => {})"
                        color="primary"
                        type="filled"
                        class="customizer-btn">Add Subscription</vs-button>
                </div>
            </slot>
        </vs-card>
        <div v-if="changeSubscriptionPlan">
            <vs-card>
                <SubscriptionForm :update="true" :upgradeablePlans="upgradeablePlans" @sub-plan-update="subscriptionPlanUpdated" />
            </vs-card>
        </div>

        <!-- POPUPS -->
        <vs-popup class="popup-confirm" title="Cancel Subscription" :active.sync="cancelSubscriptionPopupActive">
            <div class="description">Are You sure You want to cancel the subscription?</div>
            <div class="action-wrapper">
                <vs-button
                    @click="() => {cancelSubscriptionPopupActive = false}"
                    color="light"
                    type="filled"
                    class="customizer-btn cancel"><span>Cancel</span></vs-button>
                <vs-button
                    @click="updateSubscription()"
                    color="primary"
                    type="filled"
                    class="customizer-btn confirm"><span>Confirm</span></vs-button>
            </div>
        </vs-popup>
    </div>
</template>
<script>
import helperMethods from '../../../mixins/helperMethods'
import SubscriptionForm from './SubscriptionForm'
import { getStripeSubscriptions, updateStripeSubscription } from '../../../stripe/stripeHelperMethods'

export default {
    name: 'SubscriptionList',
    components: {
        SubscriptionForm
    },
    mixins: [
        helperMethods
    ],
    data() {
        return {
            stripeSubscriptions: {},
            hasSubscriptions: false,
            changeSubscriptionPlan: false,
            cancelSubscriptionPopupActive: false,
            selectedSubscription: {},
            updateProps: {},
            stripePlans: {},
            stripeProducts: {},
            upgradeablePlans: []
        }
    },
    mounted() {
        this.stripeSubscriptions = this.$store.state.AppActiveUser.stripeSubscriptions
        this.hasSubscriptions = this.$store.state.AppActiveUser.hasSubscriptions
        this.stripePlans = this.$store.state.AppActiveUser.stripePlans
        this.stripeProducts = this.$store.state.AppActiveUser.stripeProducts
        this.canUpgradePlan()
    },
    methods: {
        canUpgradePlan() {
            if (this.stripePlans.data && this.stripeSubscriptions.data) {
                // There should not be more than 1 subscription per customer
                this.upgradeablePlans = this.stripePlans.data.filter(plan => plan.amount > this.stripeSubscriptions.data[0].plan.amount);
            }
        },
        getProductName(plan) {
            return this.stripeProducts.data[this.stripeProducts.data.findIndex(product => product.id === plan.product)].name;
        },
        beforeUpdateSubscription(sub, updateProps, prompt = true) {
            this.selectedSubscription = sub
            this.updateProps = updateProps
            this.updateProps.subscription_id = this.selectedSubscription.id

            if (prompt) {
                this.cancelSubscriptionPopupActive = true
            } else {
                this.updateSubscription()
            }
        },
        updateSubscription() {
            this.cancelSubscriptionPopupActive = false;
            this.$vs.loading()

            updateStripeSubscription(this.updateProps)
                .then (() => {
                    //console.log('...Update subscription POST result:', result)

                    // Refresh the whole subs list
                    getStripeSubscriptions(this.$store.state.AppActiveUser.stripe_id)  
                        .then (result => {
                            //console.log('subscription GET result:', result)
                            this.stripeSubscriptions = (result.data.data && result.data.data.length > 0) ? result.data : {};
                            this.hasSubscriptions = this.hasData(this.stripeSubscriptions)
                            this.$store.commit('UPDATE_USER_INFO', { stripeSubscriptions: this.stripeSubscriptions, hasSubscriptions: this.hasSubscriptions }, { root: true })
                            this.$vs.notify({
                                title: 'Plan subscription update',
                                text: 'Updated the selected subscription succesfully',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle',
                                color: 'success'
                            })
                        }).catch(err => {
                            this.hasSubscriptions = false
                            this.$vs.notify({
                                title: 'Plan subscription update',
                                text: 'Error occured while fetching updated subscriptions: ' + err.response.data.raw.message,
                                iconPack: 'feather',
                                icon: 'icon-alert-circle',
                                color: 'danger'
                            })
                        })
                }).catch(err => {
                    this.hasSubscriptions = false
                    this.$vs.notify({
                        title: 'Plan subscription update',
                        text: 'Error occured while fetching subscriptions: ' + err.response.data.raw.message,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }).finally(() => {
                    this.$vs.loading.close()
                })
        },
        subscriptionPlanUpdated(updatedSubs) {
            this.stripeSubscriptions = updatedSubs
            this.changeSubscriptionPlan = false
            this.canUpgradePlan()
            this.$emit('sub-plan-update', updatedSubs)
        }
    }
}
</script>
<style scoped>
.con-vs-chip {
    text-align: center;
}
.con-vs-chip.active :hover {
    cursor: pointer;
}
.popup-confirm .description {
    margin-bottom: 20px;
    font-weight: bold;
}
.popup-confirm .customizer-btn {
    margin: 0 10px;
}
.popup-confirm .customizer-btn.cancel {
    color: #6c6c6c;
}
.popup-confirm .action-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
}
.no-sub-desc p {
    margin: 10px 0;
}
</style>